import React from 'react';
import Form from '@updater-core/uds/components/Form';
import Input from '@updater-core/uds/components/Input';
import Button from '@updater-core/uds/components/Button';
import Card from '@updater-core/uds/components/Card';
import classes from './index.module.css';

export default function SignIn({
  actions: { changeEmail, changePassword, clickForgotPassword, submit },
  state: {
    email,
    password,
    signInCtaDisabled,
    signInCtaText,
    errorMessage,
    successMessage,
  },
}) {
  return (
    <div className="uds-page-g-3">
      {successMessage && (
        <Card green className="uds-p-2">
          <div className="uds-body-1 sign-in-success-message">
            {successMessage}
          </div>
        </Card>
      )}
      <div className="uds-title-4">Please sign in.</div>
      <Form onSubmit={submit} className="uds-page-g-3">
        <Input
          value={email.value}
          valid={email.valid}
          message={email.message}
          name="email"
          label="Email"
          onChange={changeEmail}
        />
        <Input
          type="password"
          value={password.value}
          valid={password.valid}
          message={password.message}
          name="password"
          label="Password"
          onChange={changePassword}
        />
        {errorMessage && (
          <Card error className="uds-p-2">
            <div className="uds-body-1">{errorMessage}</div>
          </Card>
        )}
        <div className={classes.controls}>
          <a
            href="/forgot-password"
            className="uds-link-2"
            onClick={clickForgotPassword}
          >
            I forgot my password
          </a>
          <Button
            type="submit"
            label={signInCtaText}
            disabled={signInCtaDisabled}
          />
        </div>
      </Form>
    </div>
  );
}
